import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { contactsApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

export const useDuplicateContact = (
  currentAssetId?: string,
  options?: UseMutationOptions<unknown, unknown, { contactId: string; targetAssetIds: string[] }>
) => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, { contactId: string; targetAssetIds: string[] }>(
    ['duplicate-contact', currentAssetId],
    async ({ contactId, targetAssetIds }: { contactId: string; targetAssetIds: string[] }) => {
      if (!currentAssetId) {
        throw new Error('No asset selected');
      }
      const response = await contactsApi.contactsControllerDuplicate(contactId, currentAssetId, {
        targetAssetIds,
      });

      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        options?.onSuccess?.(data, variables, context);
        variables.targetAssetIds.map(assetId =>
          queryClient.invalidateQueries(['fetch-contacts', assetId])
        );
        trackEvent('Contact', 'duplicate');
      },
    }
  );
};
